import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { type ColorValue, Flex, useColorSchemeValue } from "@hopper-ui/components";
import type { RefObject } from "react";

interface Props {
    ref: RefObject<HTMLDivElement | null> | null;
}

export const AssistantMessageBlocked = ({ ref } : Props) => {
    const { tShared } = useSharedTranslation();

    const textColor = useColorSchemeValue(
        "danger",
        "warning-text-weak"
    ) as ColorValue;

    return (
        <Flex ref={ref} direction="column" gap="inline-md">
            <Flex
                direction="column"
                gap="inline-md"
                backgroundColor="danger-weak"
                padding="inset-md"
                borderRadius="pill"
                wordBreak="break-word"
            >
                <Flex
                    alignItems="center"
                    gap="inline-sm"
                    fontSize="body-sm"
                    color={textColor}
                    className="wai-assistant-message-blocked-text"
                    UNSAFE_lineHeight="var(--wai-line-height)"
                >
                    {tShared("errors.blockedMessage")}
                </Flex>
            </Flex>
        </Flex>
    );
};
